import React from 'react';
import { RequestHistoryUi } from './ui';
import { useRequestHistory } from './useRequestHistory';
import { useMyProfile } from '../my-profile';
import { useContracts } from '../contracts';
import { withLoadingAndNoConnectionHandler } from '../integration-wrapper';

const RequestHistoryWithHandlers = withLoadingAndNoConnectionHandler(RequestHistoryUi);

export const RequestHistory: React.FC = () => {
    const profile = useMyProfile();
    const {
        data: cases,
        isLoading: isRequestHistoryLoading,
        loadingError: requestHistoryLoadingError,
    } = useRequestHistory(profile?.data?.identification?.data?.customerNumber || '');
    const { data: contracts, isLoading: isContractsLoading, loadingError: contractsLoadingError } = useContracts();
    const isLoading = isRequestHistoryLoading || isContractsLoading;
    const loadingError = requestHistoryLoadingError || contractsLoadingError;
    return (
        <RequestHistoryWithHandlers
            cases={cases?.requestsInCaseHistory}
            contracts={contracts || []}
            isLoading={isLoading}
            hasError={!!loadingError}
        />
    );
};
